export const PAGES = {
    cart: 'CART_PAGE',
    cartOrCheckout: 'CART_OR_CHECKOUT_PAGE',
    checkout: 'CHECKOUT_PAGE',
    checkoutLogin: 'CHECKOUT_LOGIN_PAGE',
    orderConfirmation: 'ORDER_CONFIRMATION_PAGE',
};

export const SENTRY_EVENTS = {
    EMPTY_CART_PAGE_LOADED: {
        page: PAGES.cart,
        action: 'EMPTY_CART_PAGE_LOADED',
    },
    CART_PAGE_LOADED: { page: PAGES.cart, action: 'CART_PAGE_LOADED' },
    CHECKOUT_PAGE_LOADED: {
        page: PAGES.checkout,
        action: 'CHECKOUT_PAGE_LOADED',
    },
    CHECKOUT_LOGIN_PAGE_LOADED: {
        page: PAGES.checkoutLogin,
        action: 'CHECKOUT_LOGIN_PAGE_LOADED',
    },
    ORDER_CONFIRMATION_PAGE_LOADED: {
        page: PAGES.orderConfirmation,
        action: 'ORDER_CONFIRMATION_PAGE_LOADED',
    },
    NAVIGATE_TO_CHECKOUT: { page: PAGES.cart, action: 'NAVIGATE_TO_CHECKOUT' },
    CC_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'CC_ORDER_CLICK',
    },
    AFTERPAY_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'AFTERPAY_ORDER_CLICK',
    },
    PAYPAL_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'PAYPAL_ORDER_CLICK',
    },
};

export const SENTRY_ERRORS = {
    NAVIGATE_TO_CHECKOUT_FAILED: {
        page: PAGES.cart,
        action: 'NAVIGATE_TO_CHECKOUT_FAILED',
    },
    CART_VALIDATION_ERROR: {
        page: PAGES.cartOrCheckout,
        action: 'CART_VALIDATION_ERROR',
    },
    CART_VALIDATE_OR_REDIRECT_ERROR: {
        page: PAGES.cartOrCheckout,
        action: 'CART_VALIDATE_OR_REDIRECT_ERROR',
    },
    CART_ADD_ITEM_ERROR: {
        page: PAGES.cart,
        action: 'CART_ADD_ITEM_ERROR',
    },
    CART_FETCH_STORES_ERROR: {
        page: PAGES.cart,
        action: 'CART_FETCH_STORES_ERROR',
    },
    CART_CHANGE_FM_ERROR: {
        page: PAGES.cart,
        action: 'CART_CHANGE_FM_ERROR',
    },
    CC_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'CC_ORDER_ERROR',
    },
    PAYPAL_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'PAYPAL_ORDER_ERROR',
    },
};

export const SENTRY_CONTEXT = {
    ...SENTRY_EVENTS,
    ...SENTRY_ERRORS,
};

export type SentryContextKey = keyof typeof SENTRY_CONTEXT;
export type SentryContextType = (typeof SENTRY_CONTEXT)[SentryContextKey];
